import { ref } from 'vue';

// Глобальное состояние диалога букинга — один диалог на приложение,
// монтируется в App.vue (MeetingDialog).
const isMeetingOpen = ref(false);
const bookingSource = ref('unknown');

export function useMeeting() {
  const openMeeting = (source: string) => {
    bookingSource.value = source;
    isMeetingOpen.value = true;
    document.body.classList.add('hs-meeting-open');
  };

  const closeMeeting = () => {
    isMeetingOpen.value = false;
    document.body.classList.remove('hs-meeting-open');
  };

  return { isMeetingOpen, bookingSource, openMeeting, closeMeeting };
}
